import { getUrl } from "@/common/config";

export default class BaseApi {
  constructor(organizationCode) {
    // Get org id from passed in var
    this.organizationCode = organizationCode || localStorage.organizationCode;

    this.url = getUrl();
    this.me = localStorage.userId;
  }

  get organizationCode() {
    if (!this.orgCode || this.orgCode !== localStorage.organizationCode) {
      this.organizationCode = localStorage.organizationCode;
    }

    return this.orgCode;
  }

  set organizationCode(newValue) {
    this.orgCode = newValue || localStorage.organizationCode;
  }

  async getAll(_apiGet, _params = {}) {
    let skip = 0;
    let data = [];
    const limit = 100;

    const params = {
      ..._params,
      skip,
      limit
    };

    const emptyResult = { total: 0, result: [] };

    try {
      const { total, result } = await _apiGet(params);

      data = result;

      while (total > limit * (skip + 1)) {
        skip++;
        const res = await _apiGet({
          ...params,
          skip: skip * limit,
          limit
        });
        data = [...data, ...res.result];
      }

      return {
        result: data,
        total
      };
    } catch (e) {
      console.error(e);
      return emptyResult;
    }
  }
}
